import * as authHelpers from "./authHelpers";

export function buildRoute(route, params = "") {
  let accountUniqueName = authHelpers.getAccountUniqueNameFromUrl();

  return `/${accountUniqueName}${route}${params}`;
}
